import React, { FC } from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";

const useStyles = makeStyles(() => ({
  circularChart: {
    display: "block",
  },
  circleBg: {
    fill: "none",
    stroke: "#eee",
    strokeWidth: 4,
  },
  circle: {
    fill: "none",
    strokeWidth: 4,
    strokeLinecap: "round",
  },
  text: {
    fontFamily: "sans-serif",
    fontSize: "0.9em",
    fontWeight: 600,
    textAnchor: "middle",
  },
}));

interface ICircularProgress {
  percent?: number;
  color?: string;
  size?: string;
  text?: string;
  textColor?: string;
}

const CircularProgress: FC<ICircularProgress> = ({
  percent = 0,
  color = "#7EC884",
  size = "100px",
  text = "",
  textColor = "#666",
}) => {
  const classes = useStyles();

  return (
    <div style={{ width: size }}>
      <svg viewBox="0 0 36 36" className={classes.circularChart}>
        <path
          className={classes.circleBg}
          d="M18 2.0845
          a 15.9155 15.9155 0 0 1 0 31.831
          a 15.9155 15.9155 0 0 1 0 -31.831"
        />
        <path
          className={classes.circle}
          stroke={percent === 0 ? "#eee" : color}
          strokeDasharray={`${percent}, 100`}
          d="M18 2.0845
          a 15.9155 15.9155 0 0 1 0 31.831
          a 15.9155 15.9155 0 0 1 0 -31.831"
        />
        <text
          x="18"
          y="22.35"
          className={classes.text}
          style={{ fill: textColor }}
        >
          {text}
        </text>
      </svg>
    </div>
  );
};

export default CircularProgress;
